import { render, staticRenderFns } from "./PrimerOSG.vue?vue&type=template&id=12cfeee3&scoped=true&"
import script from "./PrimerOSG.vue?vue&type=script&lang=js&"
export * from "./PrimerOSG.vue?vue&type=script&lang=js&"
import style0 from "./PrimerOSG.vue?vue&type=style&index=0&id=12cfeee3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cfeee3",
  null
  
)

export default component.exports